import { BaseBadge } from '@/shared/components'
import { getPercentChange } from './lib'

type BalanceChangeBadgeProps = {
  yesterdayBalance: number
  currentBalance: number
  className?: string
}

export const BalanceChangeBadge = ({
  yesterdayBalance,
  currentBalance,
  className,
}: BalanceChangeBadgeProps) => {
  const percentChange = getPercentChange(yesterdayBalance, currentBalance)
  const roundedPercent = Math.round(percentChange * 10) / 10

  const isPositive = roundedPercent >= 0
  const type = isPositive ? 'more' : 'less'

  return (
    <BaseBadge type={type} icon className={className}>
      На {roundedPercent}% {isPositive ? 'больше' : 'меньше'}, чем вчера
    </BaseBadge>
  )
}
